<template>
    <ComHuonekorttiMuokkausHuonekortti />
    <el-divider border-style="none"/>
    <ComHuonekorttiMuokkausTable />
</template>

<script setup lang="ts">
import { HuonekorttiResponse } from '@/api/models/huonekortti-response';
import { onUnmounted, PropType } from 'vue';
import { useHuonekorttiMuokkausComponent } from './huonekorttiMuokkaus';
import ComHuonekorttiMuokkausTable from './ComHuonekorttiMuokkausTable.vue';
import ComHuonekorttiMuokkausHuonekortti from './ComHuonekorttiMuokkausHuonekortti.vue';

const props = defineProps({
    huonekortit: {
        type: Object as PropType<HuonekorttiResponse[]>,
        required: true,
    }
})
const { huonekortit: _huonekortit, resetState } = useHuonekorttiMuokkausComponent()

_huonekortit.value = structuredClone(props.huonekortit)

onUnmounted(() => {
    resetState()
})
</script>